import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Stack,
  useMediaQuery,
  useTheme,
  Snackbar,
  SnackbarContent,
  IconButton,
  CircularProgress,
  Modal,
  Grid,
  Grid2,
  Tooltip,
} from '@mui/material';
import { Close, InfoOutlined } from '@mui/icons-material';
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import Esign from "../../../Assets/Images/esign_img.svg";
import Logo from '../../../Assets/Images/logo.svg';
import eSignStyles from "./eSign.module.css";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { esignProceed, setEsignStatus, setClientId } from '../../../Redux/usersSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import collab from '../../../Assets/Images/collab1.svg';

const AadhaarESign = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const { loading, userData,source } = useSelector(state => state.user);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // State management
  const [buttonLoading, setButtonLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [esignStatus, setEsignStatusState] = useState('pending');
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [esignUrl, setEsignUrl] = useState('');
   const [hasInitialized, setHasInitialized] = useState(false); // Add this to track initialization
   const [eStampFailed,setEstampFailed]= useState(false)

  // Function to trigger error email
  const triggerErrorEmail = async (errorDescription) => {
    try {
      // Determine the environment and set the appropriate URL
      const baseHostName = window.location.hostname;
      const emailServiceUrl = !(baseHostName.includes("localhost") || baseHostName.includes("staging"))
        ? 'https://email-micro-service.tradeboss.co/tradeboss/error'
        : 'https://email-micro-service-staging.tradeboss.co/tradeboss/error';

      const errorPayload = {
        service: "Registration",
        api_endpoint: "/esign/authorize",
        description: "Environment --> " + baseHostName + "--> " + errorDescription   
      };

      console.log('Sending error email to:', emailServiceUrl);

      const response = await fetch(emailServiceUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(errorPayload)
      });

      if (response.status !== 200) {
       console.log(`HTTP error! status: ${response.status}`);
      }

      console.log('Error email sent successfully');
    } catch (error) {
      console.error('Failed to send error email:', error);
      // Don't show this error to user, just log it
    }
  };

  // Check if eSign is already done
  useEffect(() => {
    const isEsignNotPresent = !("Esign" in (userData?.steps || {}));
    const isEsignDone = userData?.steps?.["Esign"]?.status;

    console.log("isEsignNotPresent", isEsignNotPresent, "isEsignDone", isEsignDone);
    if (isEsignDone || isEsignNotPresent) {
      navigate('/products');
    }else{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "esign_page_viewed",
        page_path: window.location.pathname
      });
    }
  }, [userData, navigate]);

  
  const initializeEsign = async () => {
    if (hasInitialized) return; // Prevent multiple initializations
    if(userData?.steps?.["Esign"]?.status) return;
    setInitLoading(true);
    try {
      console.log("Making initial API call to get eSign URL...");
      
      const response = await dispatch(esignProceed({
        email: userData.email.toLowerCase(),
        mobile: userData.mobile,
        source: "accountOpening"
      })).unwrap();

      console.log("eSign initialization response:", response);

      if (response.data.data.success && response?.data?.data?.code !== "2") {
        setEsignUrl(response.data.data?.url);
        dispatch(setClientId(response.data?.data?.client_id))
        setIsButtonEnabled(true);
        setEsignStatusState('ready');
        setHasInitialized(true); // Mark as initialized
        console.log("eSign URL obtained successfully:", response.data.data.url);
      } else if (response.data.data.success && response?.data?.data?.code == "2"){
        setEstampFailed(true) 
        setEsignUrl(response.data.data?.url);
        dispatch(setClientId(response.data?.data?.client_id))
        setIsButtonEnabled(true);
        setEsignStatusState('ready');
        setHasInitialized(true); // Mark as initialized
        console.log("eSign URL obtained successfully:", response.data.data.url);
      } else {
        throw new Error("Failed to get eSign URL");
      }
      
    } catch (error) {
      console.error('Initialization error:', error);
       // Trigger error email for initialization error
      const errorDescription = `eSign initialization error for user: ${userData.email}. Error: ${error.message}`;
      triggerErrorEmail(errorDescription);
      setSnackbarMessage("Failed to initialize eSign system");
      setShowSnackbar(true);
      setIsButtonEnabled(false);
      setEsignStatusState('failed');
      setHasInitialized(true); // Mark as initialized even on failure
    } finally {
      setInitLoading(false);
    }
  };

      // Handle URL parameters and success/failure flows - FIXED useEffect
  useEffect(() => {
    const handleUrlParams = async () => {
      const success = searchParams.get("success");
      console.log("URL success parameter:", success);
      if (success === "true") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "esign_captured",
          page_path: window.location.pathname
        });
        // Success flow
        const baseUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, baseUrl);
        setShowSuccessModal(true);
        setEsignStatusState('completed');
        setIsButtonEnabled(false);
        setInitLoading(false);
        return;
      }

      if (success === "false") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "esign_captured",
          page_path: window.location.pathname
        });
        // Failure flow
        const baseUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, baseUrl);
        console.log("API Call Triggered: Rejection Flow");
        // Trigger error email for eSign failure
        const errorDescription = `eSign process failed for user: ${userData?.email.toLowerCase() }. User returned from eSign portal with failure status.`;
        triggerErrorEmail(errorDescription);
        setShowFailureModal(true);
        setIsButtonEnabled(true);
        setInitLoading(false);
        setEsignStatusState('failed');

        return;
      }
    };

    handleUrlParams();

    // Only initialize eSign if no success/failure parameters and not already initialized
    const success = searchParams.get("success");
    if (!success && !hasInitialized) {
      const baseUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, baseUrl);
      initializeEsign();
    }
  }, [searchParams]); // Remove initLoading from dependencies

  const handleProceedToEsign = async () => {
    if (!isButtonEnabled || !esignUrl) return;
    
    setButtonLoading(true);
    setEsignStatusState('initiated');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "esign_initiated",
      page_path: window.location.pathname
    });
    try {
      console.log("Redirecting to eSign URL:", esignUrl);
      window.open(esignUrl, "_self");
      
    } catch (error) {
      console.error('Redirect error:', error);
      setSnackbarMessage("Failed to redirect to eSign portal");
      setShowSnackbar(true);
      setIsButtonEnabled(true);
      setEsignStatusState('ready');
    } finally {
      setButtonLoading(false);
    }
  };

    const handleSuccessContinue = () => {
        dispatch(setEsignStatus());

        setShowSuccessModal(false);
        navigate('/products');
    };

   const handleFailureRetry = () => {
    setShowFailureModal(false);
    // Reset and reinitialize
    setHasInitialized(false);
    setInitLoading(true);
    initializeEsign();
  };

  const handleFailureContinue = () => {
    setShowFailureModal(false);
    navigate('/products');
  };


  // Success Modal Component
  const SuccessModal = () => (
    <Modal
      open={showSuccessModal}
      disableEscapeKeyDown // Prevent closing with ESC key
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(5px)',
      }}
    >
      <Box
        sx={{
          background: "#fff",
          borderRadius: "16px",
          padding: "30px 20px",
          textAlign: "center",
          color: "#F3D45E",
          maxWidth: "400px",
          width: "90%",
          margin: "20px",
          border: "2px solid #F3D45E",
        }}
      >
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <Box
                      component="svg"
                      width="80px !important"
                      height="80px !important"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      sx={{ color: '#BCD171' }}
                  >
                      <path
                          d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                      />
                  </Box>
              </Box>
        
        <Typography
          sx={{
             fontFamily: "Inter400",
            color: "#BCD171",
            fontSize: "22px",
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          eSign Successful!
        </Typography>

        <Typography sx={{ 
          color: "#000", 
          fontSize: "15px", 
          marginTop: "10px", 
           fontFamily: "Inter400",
          lineHeight: "1.5",
        }}>
          Your account opening form has been signed successfully.
        </Typography>

        <Box sx={{ justifyContent: "center", marginTop: "25px" }}>
          <Button
            variant="contained"
            onClick={handleSuccessContinue}
            sx={{
              backgroundColor: "#F3D45E",
              color: "#1B2636",
              textTransform: "none",
              borderRadius: "20px",
              padding: "8px 30px",
               fontFamily: "Inter400",
              fontSize: "14px",
              "&:hover": {
                backgroundColor: "#e4c852",
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );

  // Failure Modal Component
  const FailureModal = () => (
    <Modal
      open={showFailureModal}
      disableEscapeKeyDown // Prevent closing with ESC key
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(5px)',
      }}
    >
      <Box
        sx={{
          background: "#fff",
          borderRadius: "16px",
          padding: "30px 20px",
          textAlign: "center",
          color: "#F3D45E",
          maxWidth: "450px",
          width: "90%",
          margin: "20px",
          border: "2px solid #F74542",
        }}
      >
        <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: window.innerWidth < 481 ? '5%' : '0%' }}>
          <Box
            component="svg"
            width="80px !important"
            height="80px !important"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ color: '#F74542' }}
          >
            <path 
              d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </Box>
        </Grid>
        
        <Typography
          sx={{
            fontFamily: "Inter400",
            color: "#F74542",
            fontSize: "22px",
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          eSign Failed
        </Typography>

        <Typography sx={{ 
          color: "#000", 
          fontSize: "15px", 
          marginTop: "10px", 
           fontFamily: "Inter400",
          textAlign: "center",
          lineHeight: "1.5",
        }}>
          We couldn't complete the eSign process. This might be due to some internal issue our team will contact you soon
        </Typography>

        <Box sx={{ 
          justifyContent: "center", 
          marginTop: "25px",
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
        }}>
        
          <Button
            variant="contained"
            onClick={handleFailureRetry}
            sx={{
              backgroundColor: "#F3D45E",
              color: "#1B2636",
              textTransform: "none",
              borderRadius: "20px",
              padding: "8px 25px",
               fontFamily: "Inter400",
              fontSize: "14px",
              margin: "0 5px",
              "&:hover": {
                backgroundColor: "#e4c852",
              },
            }}
          >
           Retry
          </Button>
        
        </Box>
      </Box>
    </Modal>
  );

  // Render different content based on eSign status
  const renderStatusContent = () => {
    switch (esignStatus) {
      case 'pending':
        return (
          <Box sx={{ textAlign: 'center', my: 3 }}>
            <CircularProgress sx={{ color: '#fdd835' }} aria-label="Loading" />
            <Typography sx={{ mt: 2, fontFamily: "Inter400", fontSize: "18px" }}>
              Please wait, we are preparing your document for eSign...
            </Typography>
          </Box>
        );

      case 'initiated':
        return (
          <Box sx={{ textAlign: 'center', my: 3 }}>
            <Typography sx={{ 
              color: '#4caf50', 
              fontFamily: "Inter600", 
              fontSize: "20px",
              mb: 2
            }}>
              Your document is ready for eSign. You should be redirected to the eSign portal shortly.
            </Typography>
          </Box>
        );

      case 'completed':
        return (
          <Box sx={{ textAlign: 'center', my: 1 }}>
            <Typography sx={{ 
              color: '#4caf50', 
              fontFamily: "Inter600", 
              fontSize: "20px",
              mb: 1
            }}>
               eSign Completed Successfully!
            </Typography>
          </Box>
        );

      case 'failed':
        return (
          <Box sx={{ textAlign: 'center', my: 1 }}>
            <Typography sx={{ 
              color: '#f44336', 
              fontFamily: "Inter400", 
              fontSize: "16px",
              mb: 1
            }}>
              ❌ Failed to initialize eSign. Please try again.
            </Typography>
          </Box>
        );

      case 'ready':
        return (
          <Box sx={{ textAlign: 'center', my: 1 }}>
            <Typography sx={{ 
              color: '#4caf50', 
              fontFamily: "Inter400", 
              fontSize: "16px",
              mb: 1
            }}>
              {eStampFailed && (
                <>
                  POA is currently disabled due to an e-Stamp generation issue.
                  <br></br>

                  <Tooltip
                    title="The e-stamp couldn’t be generated during onboarding. You can enable POA later from the Back Office."
                    arrow
                    placement="top"
                  >
                    <IconButton size="small" sx={{ color: "#4caf50" }}>
                      <InfoOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              )}
               Your document is ready! Click the button below to proceed with Aadhaar eSign.
            </Typography>
          </Box>
        );

      default:
        return null;
    }
  };

  return (
    <main>
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${SignUpBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflowX: "hidden",
        "@media (max-width:450px)": {
          justifyContent: "start"
        }
      }}
    >
      <img
        src={source == "cosmos" ? collab : Logo}
        alt="Logo"
        className={source == "cosmos" ? eSignStyles.twologo : eSignStyles.logo}
        style={{ marginBottom: "15px", marginTop: "10px" }}
      />
      {
        source == "cosmos" &&
        <Typography className={eSignStyles.txt1}>
          Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
        </Typography>
      }

      <Typography
        sx={{
          fontFamily: "Inter900",
          fontSize: "52px",
          color: "#481B9D",
          marginBottom: "38px",
          textAlign: "center",
          '@media (max-width: 1300px)': {
            fontSize: '42px',
            marginBottom: '28px',
            paddingLeft: "24px",
            paddingRight: "24px"
          },
          '@media (max-width: 900px)': {
            fontSize: '32px',
            marginBottom: '20px',
            paddingLeft: "24px",
            paddingRight: "24px"
          },
          '@media (max-width: 600px)': {
            fontSize: '24px',
            marginBottom: '16px',
            paddingLeft: "24px",
            paddingRight: "24px"
          },
        }}
        className={eSignStyles.heading}
      >
        ESign the KYC Form using Aadhaar
      </Typography>

      <Box
        component="img"
        src={Esign}
        alt="Aadhaar ESign Icon"
        sx={{ marginBottom: "12px" }}
      />

      {/* Show loading state within the main layout */}
      {initLoading ? (
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <CircularProgress 
            aria-label="Loading"
            size={60} 
            thickness={4}
            sx={{ 
              color: '#481B9D',
              mb: 2 
            }} 
          />
          <Typography sx={{ 
            fontFamily: "Inter400", 
            fontSize: "20px", 
            color: "#481B9D",
            mb: 1
          }}>
            Preparing Your eSign Document
          </Typography>
          <Typography sx={{ 
            fontFamily: "Inter400", 
            fontSize: "16px", 
            color: "#666",
            maxWidth: 400,
            mx: 'auto'
          }}>
            We are setting up your documents for secure Aadhaar eSign. This will just take a moment...
          </Typography>
        </Box>
      ) : (
        <>
          <Typography sx={{
            mb: "42px", 
            fontFamily: "Inter400", 
            fontSize: "24px", 
            textAlign: "center", 
            '@media (max-width: 1300px)': {
              fontSize: '20px',
              mb: '24px',
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            '@media (max-width: 900px)': {
              fontSize: '18px',
              mb: '24px',
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            '@media (max-width: 600px)': {
              fontSize: '16px',
              mb: '18px',
              paddingLeft: "24px",
              paddingRight: "24px"
            },
          }} 
          className={eSignStyles.title1}
          >
            Aadhaar ESign digitally signs all the documents you submitted for KYC
            and account opening with Tradeboss.
          </Typography>

          <Typography sx={{
            mb: "12px", 
            fontFamily: "Inter400", 
            fontSize: "24px", 
            textAlign: "center", 
            '@media (max-width: 1300px)': {
              fontSize: '20px',
              mb: '24px',
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            '@media (max-width: 900px)': {
              fontSize: '18px',
              mb: '24px',
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            '@media (max-width: 600px)': {
              fontSize: '16px',
              mb: '24px',
              paddingLeft: "24px",
              paddingRight: "24px"
            },
          }}
          className={eSignStyles.title2}
          >
            Your Aadhaar must be linked to your mobile number to receive and
            confirm OTP
          </Typography>

          {/* Status Content */}
          {renderStatusContent()}

          {/* Action Buttons - Only show when system is ready and not in initiated or completed state */}
          {(esignStatus === 'ready' || esignStatus === 'failed') && (
            <Stack
              direction={isMobile ? 'column' : 'row'}
              spacing={2}
              justifyContent="center"
            >
              <Button
                variant="contained"
                disabled={!isButtonEnabled || buttonLoading}
                sx={{
                  backgroundColor: isButtonEnabled ? '#fdd835' : '#cccccc',
                  color: '#000',
                  '&:hover': isButtonEnabled ? { backgroundColor: '#fbc02d' } : {},
                  textTransform: "capitalize",
                  minWidth: '200px',
                  cursor: isButtonEnabled ? 'pointer' : 'not-allowed'
                }}
                className={eSignStyles.con_button}
                onClick={handleProceedToEsign}
              >
                {buttonLoading ? (
                      <CircularProgress size={24} aria-label="Loading" />
                ) : (
                  'Proceed To Aadhaar ESign'
                )}
              </Button>
            </Stack>
          )}
        </>
      )}

      {/* Success Modal */}
      <SuccessModal />

      {/* Failure Modal */}
      <FailureModal />

      {/* Snackbar for error messages */}
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        open={showSnackbar}
        autoHideDuration={5000}
        onClose={() => setShowSnackbar(false)}
      >
        <SnackbarContent
          message={snackbarMessage}
          action={
            <IconButton
              size="small"
              color="inherit"
              onClick={() => setShowSnackbar(false)}
            >
              <Close fontSize="small" />
            </IconButton>
          }
          sx={{
            backgroundColor: '#f44336',
          }}
        />
      </Snackbar>
    </Box>
    </main>
  );
};

export default AadhaarESign;